import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const META_PIXEL_ID = '2810662569268212';
const initPixel = () => {
  if ((window as any).fbq) return;
  const n: any = (window as any).fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  if (!document.querySelector('script[src*="fbevents.js"]')) {
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
  }
  ;
  (window as any).fbq('init', META_PIXEL_ID);
  (window as any).fbq('track', 'PageView');
};
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(initPixel);
} else {
  setTimeout(initPixel, 2500);
}
render(<App data-id="element-209" />, document.getElementById('root'));